import React from 'react';
import { EPermission } from 'app/types/enums/EPermission';
import { usePermission } from './usePermission';

type RestrictedProps = {
  to: EPermission;
  fallback?: JSX.Element | string;
  loadingComponent?: JSX.Element | string;
  children: React.ReactNode;
};

// This component is meant to be used everywhere a restriction based on user permission is needed
export const Restricted = ({ to, fallback, loadingComponent, children }: RestrictedProps) => {
  const [loading, allowed] = usePermission(to);

  if (loading) {
    return <>{loadingComponent}</>;
  }

  if (allowed) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
